function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.46424 2.95753C8.85511 1.34749 11.1449 1.34749 11.5358 2.95753C11.7883 3.9976 12.9799 4.49118 13.8938 3.93428C15.3087 3.07219 16.9278 4.69131 16.0657 6.10617C15.5088 7.02015 16.0024 8.21175 17.0425 8.46424C18.6525 8.85511 18.6525 11.1449 17.0425 11.5358C16.0024 11.7883 15.5088 12.9799 16.0657 13.8938C16.9278 15.3087 15.3087 16.9278 13.8938 16.0657C12.9799 15.5088 11.7883 16.0024 11.5358 17.0425C11.1449 18.6525 8.85511 18.6525 8.46424 17.0425C8.21175 16.0024 7.02015 15.5088 6.10617 16.0657C4.69131 16.9278 3.07219 15.3087 3.93428 13.8938C4.49118 12.9799 3.9976 11.7883 2.95753 11.5358C1.34749 11.1449 1.34749 8.85511 2.95753 8.46424C3.9976 8.21175 4.49118 7.02015 3.93428 6.10617C3.07219 4.69131 4.69131 3.07219 6.10617 3.93428C7.02015 4.49118 8.21175 3.9976 8.46424 2.95753Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 10C12.75 11.5188 11.5188 12.75 10 12.75C8.48122 12.75 7.25 11.5188 7.25 10C7.25 8.48122 8.48122 7.25 10 7.25C11.5188 7.25 12.75 8.48122 12.75 10Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.a3d79732.svg";
export { ForwardRef as ReactComponent };